import React from 'react';
import PropTypes from 'prop-types';

import { activeFiltersPropType } from '../../../../../components/report-filters/filter-prop-types';
import { SELECTED_CLASS } from '../../../../../components/report-filters/filter-constants';

import { hasValidCourses } from '../../student-helpers';

import StudentDataTable from '../student-data-table/student-data-table';
import CourseEmptyState from '../course-empty-state/course-empty-state';

/**
 * TABLE DISPLAY
 * ----------------------
 * Acts as conditional table rendering to optimise performance.
 */
class TableDisplay extends React.Component {
    static propTypes = {
        activeFilters: activeFiltersPropType,
        isLoading: PropTypes.bool,
        skillQuestsMasteryStudentData: PropTypes.object,
        onCompletedTextClickHandler: PropTypes.func,
        assignmentResultType: PropTypes.number
    };

    shouldComponentUpdate(nextProps) {
        const skillQuestsMasteryStudentData = JSON.stringify(
            this.props.skillQuestsMasteryStudentData
        );
        const newSkillQuestsMasteryStudentData = JSON.stringify(
            nextProps.skillQuestsMasteryStudentData
        );

        return (
            skillQuestsMasteryStudentData !== newSkillQuestsMasteryStudentData
        );
    }

    render() {
        const {
            skillQuestsMasteryStudentData,
            activeFilters,
            isLoading,
            onCompletedTextClickHandler,
            assignmentResultType
        } = this.props;

        const checkValidCourses = hasValidCourses(
            skillQuestsMasteryStudentData
        );
        const shouldRenderTable = !isLoading && checkValidCourses;
        const shouldRenderEmptyState = !isLoading && !checkValidCourses;

        if (!skillQuestsMasteryStudentData) {
            return null;
        }

        if (shouldRenderTable) {
            return (
                <StudentDataTable
                    skillQuestsMasteryStudentData={
                        skillQuestsMasteryStudentData
                    }
                    selectedClassId={activeFilters[SELECTED_CLASS].id}
                    onCompletedTextClickHandler={onCompletedTextClickHandler}
                    assignmentResultType={assignmentResultType}
                />
            );
        }

        if (shouldRenderEmptyState) {
            return (
                <CourseEmptyState
                    onClickHandler={onCompletedTextClickHandler}
                />
            );
        }

        return null;
    }
}

export default TableDisplay;



// WEBPACK FOOTER //
// ./containers/skill-quests-mastery/student/components/table-display/table-display.js